import './assets/css/style.css';

import api from './api';

interface Params {
    credential:{
        host: string;
        token: string;
        userkey: string;
    },
    setting?:{
        position?: any;
        width?: number;
        height?: number;
        header?: {
            title?: string;
            color?: string;
        },
        dom?:{
            embed?: HTMLElement,
            fit?: boolean
        }
    }
}

interface Callback{
    [key:string] : (e:any)=>{}
}

export default class IONWidget {

    protected pos1  : number        = 0;
    protected pos2  : number        = 0;
    protected pos3  : number        = 0
    protected pos4  : number        = 0;
    private host    : string | null = null
    private apikey  : string | null = null
    private userkey : string | null = null
    private position: any           = 'right'
    private width   : number        = 250
    private height  : number        = 245

    private widgetTitle:string      = `<i class="icon-phone-outline"></i> ION Phone`;
    private colorHeader:string|null = null;
    private settingDom:{embed:HTMLElement|null, fit:boolean} = {embed:null, fit:true};

    constructor(param:Params){
        this.host               = param.credential.host || null;
        this.apikey             = param.credential.token || null;
        this.userkey            = param.credential.userkey || null;

        this.position           = param?.setting?.position || 'right';
        this.width              = param?.setting?.width || 250;
        this.height             = param?.setting?.height || 245;
        this.widgetTitle        = param?.setting?.header?.title || `<i class="icon-phone-outline"></i> ION Phone`;
        this.colorHeader        = param?.setting?.header?.color || null;
        this.settingDom.embed   = param?.setting?.dom?.embed || null;
        this.settingDom.fit     = param?.setting?.dom?.fit || true;
        
    }

    callback:Callback = {
        "connection-status": (e:any)=>{ return e },
        "registration-status": (e:any)=>{ return e },
        "call-listen": (e:any)=>{ return e },
        "call-status": (e:any)=>{ return e },
        "dial-established": (e:any)=>{ return e },
        "unregistered": (e:any)=>{ return e },
        "auto-dial": (e:any)=>{ return e },
        "info": (e:any)=>{ return e },
        "queue": (e:any)=>{ return e },
    };

    async init(){

        try {
            const phoneCfg          = await api({url:`${this.host}/api/config`,method:'POST',auth:this.apikey,data:{userkey:this.userkey}});
            const token             = phoneCfg.result.token || null;
            const webphone          = phoneCfg.result.webphone || null

            this.generateFrame(token, webphone);
            window.addEventListener("message", this.receiveMessage.bind(this), false);

        } catch (error) {
            this.generateFrame();
        }

        if(this.colorHeader){

            const basicColor        = this.colorHeader.substring(0,1)=="#" ? this.colorHeader.padEnd(7,'0'): `#${this.colorHeader.padEnd(7,'0')}`; 
            const header            = document.querySelector(".IONPhone-header") as HTMLDivElement;
            header.style.background = `linear-gradient(#ffffffcc, ${basicColor}cc, ${basicColor})`;
            header.style.border     = `1px solid ${basicColor}`;
      
        }
        
    }

    private receiveMessage(event: any) {
        try {
            const tipe = event?.data?.message;
            if(tipe){
                const callbackStr = tipe.toString().toLowerCase().replace(/_/g, "-");
                if(this.callback[callbackStr]){
                    this.callback[callbackStr](event?.data?.payload || null);
                }
            }
            if(tipe=="CALL_STATUS"){
                const payloadStatus = event?.data?.payload?.status || null;
                this.collapseWidget(true);
                if(payloadStatus==="FINISH"){
                    this.headerUpdate(null);
                }else{
                    const titleStr = `<i class="IONPhone-flash IONPhone-animated icon-dot-circled"></i> Call ${payloadStatus}`;
                    this.headerUpdate(titleStr);
                }
            }
            if(tipe=="CALL_LISTEN"){
                const payloadStatus = event?.data?.payload?.status || null;
                this.collapseWidget(true);
                
                const titleStr = `<i class="IONPhone-flash IONPhone-animated icon-dot-circled"></i> Incoming Call - ${payloadStatus}`;
                this.headerUpdate(titleStr);
            }   
        } catch (error) {
            
        }
    }

    private headerUpdate(strReplace:string|null):void{
        try {
            const title     = document.querySelector(".IONPhonetitle") as HTMLDivElement;
            if(strReplace){
                title.innerHTML = strReplace;
            }else{
                title.innerHTML = this.widgetTitle;   
            }   
        } catch (error) {
            
        }
    }

    generateFrame(token?:string,softphone?:string){

        let $bodyContent    = '<div class="IONPhone-header">';
        $bodyContent        +=      `<div class="IONPhonetitle">${this.widgetTitle}</div>`
        $bodyContent        +=          `<div class="IONPhoneoptions">`
        $bodyContent        +=              `<a class="IONPhone-hideBtn">`
        $bodyContent        +=              `<i class="icon-up-open"></i>`
        $bodyContent        +=              `</a>`
        $bodyContent        +=          `</div>`
        $bodyContent        +=          `<br clear="all"/>`
        $bodyContent        +=      `</div>`
        $bodyContent        +=      `<div class="IONPhonecontent IONPhone-responsive">`
        $bodyContent        +=          `<div class="IONPhone-loader">`
        $bodyContent        +=              `${ softphone ? "Loading Softphone" :"System Error"}`
        $bodyContent        +=          `</div>`

        if(softphone)
        {
            $bodyContent   +=           `<form class="ion-form-plugin" action="${softphone}" method="post" target="ion-iframe-dialer">`
            $bodyContent   +=               `<input type="hidden" name="token" value="">`
            $bodyContent   +=           `</form>`
            $bodyContent   +=           `<iframe name="ion-iframe-dialer" id="ion-iframe-dialer" src="${softphone}" allow="microphone"></iframe>`
        }

        $bodyContent        +=       `</div>`
        $bodyContent        += `</div>`;


        let width               = this.width >= 250 ? this.width : 250; 
        let height              = this.height >= 245 ? this.height : 245 ; 

        if(! document.querySelector('#IONPhone') ){
            let $elemContent    = document.createElement('div');
            $elemContent.setAttribute('id','IONPhone');
            $elemContent.className='IONPhone';
            $elemContent.innerHTML=$bodyContent;

            if(this.settingDom.embed instanceof HTMLElement){
                this.settingDom.embed.appendChild($elemContent);

                if(this.settingDom.fit)
                {
                    const  domWidth             = this.settingDom.embed.offsetWidth;
                    const  domHeight            = this.settingDom.embed.offsetHeight;
                    $elemContent.style.resize   = "none";
                    width                       = domWidth >= 235 ? domWidth : 250;
                    height                      = domHeight >= 230 ? domHeight : 245;
                }

                const optBtn = document.querySelector('.IONPhoneoptions') as HTMLDivElement;
                optBtn.style.display = "none";
            }else{
                document.body.appendChild($elemContent);
            }
        }

        const pos               = ['left','right'];
        const position          = pos.indexOf(this.position)>=0?this.position:'right';
        const $widget           = document.querySelector('.IONPhone') as HTMLDivElement;
        $widget.style.width     = `${width}px`;
        $widget.style.height    = `${height}px`;
        $widget.dataset.height  = `${height}px`;

        if(!this.settingDom.embed) $widget.style[position] = '0px';

        if(softphone)
        {

            const IFrame = document.querySelector("#ion-iframe-dialer") as HTMLIFrameElement;
            IFrame.addEventListener("onload",()=>{
                const loader = document.querySelector(".IONPhone-loader") as HTMLDivElement;
                loader.style.display = "none";
            });
            
            new Promise<void>(async(resolve, reject) => {
                const TokenInputElem = document.querySelector('form.ion-form-plugin > [name="token"]') as HTMLInputElement;
                if(TokenInputElem && token) TokenInputElem.value = token
                if(token){
                    resolve()
                }else{
                    reject()
                }
            }).then(()=>{
                const FormPluginElem = document.querySelector('.ion-form-plugin') as HTMLFormElement;
                if(FormPluginElem) FormPluginElem.submit();
            }).catch(()=>{

            })

            const LoaderElem = document.querySelector(".IONPhone-loader") as HTMLDivElement;
            LoaderElem.style.display = "none";
        }


        const Header    = document.querySelector(".IONPhone-header") as HTMLDivElement;
        const HideBtn   = document.querySelector(".IONPhone-hideBtn") as HTMLAnchorElement;

        if(!this.settingDom.embed)
        {
            Header.addEventListener("mousedown",this.dragMouseDown.bind(this));
            HideBtn.addEventListener("click",this.collapseWidget.bind(this,false));
        }else{
            Header.style.cursor = "default";
        }
    }

    private collapseWidget(show:boolean=false):void {
        
        const $widget     = document.querySelector('.IONPhone') as HTMLDivElement;
        const $content    = document.querySelector('.IONPhonecontent') as HTMLDivElement;
        const $icon       = document.querySelector('.IONPhoneoptions') as HTMLDivElement;
        try {
            
            if($widget && $content){
                
                if($content.style.display =='none' || show){
                    $content.style.display='block';
                    $icon.style.transform = "rotate(0deg)";
                    if($widget.dataset.height) $widget.style.height = `${$widget.dataset.height}px`;

                }else{
                    $widget.dataset.height = $widget.offsetHeight.toString();
                    setTimeout(()=>$content.style.display='none', 150);
                    $icon.style.transform = "rotate(180deg)";
                    $widget.style.height="35px";
                }
            }
        } catch (error) {
            
        }
    }

    private dragMouseDown():void {
        const e:MouseEvent = window?.event as MouseEvent;
        e.preventDefault();

        this.pos3 = e.clientX;
        this.pos4 = e.clientY;
        
        document.onmousemove = this.elementDrag.bind(this);
        document.onmouseup = this.closeDragElement;
    }


    private elementDrag():void {
        const e:MouseEvent =  window?.event as MouseEvent;
        e?.preventDefault();

        this.pos1 = this.pos3 - e.clientX;
        this.pos2 = this.pos4 - e.clientY;
        this.pos3 = e.clientX;
        this.pos4 = e?.clientY;

        let MaxRight    = window.innerWidth;
        let MaxBottom   = window.innerHeight;

        const Frame:HTMLDivElement  = document.querySelector(".IONPhone") as HTMLDivElement;
        const Right                 = (MaxRight - Frame.offsetWidth);
        const Bottom                = (MaxBottom - Frame.offsetHeight);
        const Top                   = (Frame.offsetTop - this.pos2);
        const Left                  = (Frame.offsetLeft - this.pos1);

        if(Top >= 0 && Top <= Bottom) Frame.style.top    = Top + "px";
        if(Left >= 0 && Left <= Right) Frame.style.left   = Left + "px";
    }

    private closeDragElement():void {
        document.onmouseup = null;
        document.onmousemove = null;
    }

    setNumber($number:any, $alias:any=null){
        try {
            let params = {
                            message: "SET_NUM",
                            payload: {
                                call_id:$number,
                                alias:$alias
                    }
                };
            const Iframe = document.querySelector('#ion-iframe-dialer') as HTMLIFrameElement;
            if(Iframe.contentWindow){
                Iframe.contentWindow.postMessage(params,'*');
                this.collapseWidget(true);
            }   
        } catch (error) {
            console.trace( error );
        }
    }

    setDial($number:any, $alias:any=null){
        try {
            let params = {
                message: "DIAL",
                payload: {
                    call_id:$number,
                    alias:$alias
                }
            };

            const Iframe = document.querySelector('#ion-iframe-dialer') as HTMLIFrameElement;
            if(Iframe.contentWindow){
                Iframe.contentWindow.postMessage(params,'*');
                this.collapseWidget(true);
            }
        } catch (error) {
            console.trace( error );
        }
    }

    setHangup(){
        try {
            let params = {
                message: "HANGUP",
                payload: {}
            };

            const Iframe = document.querySelector('#ion-iframe-dialer') as HTMLIFrameElement;
            if(Iframe.contentWindow){
                Iframe.contentWindow.postMessage(params,'*');
                this.collapseWidget(true);
            }
        } catch (error) {
            console.trace( error );
        }
    }

    setQueue($paused:boolean, $reason:string|null=null){
        try {
            let params = {
                message: "SET_QUEUE",
                payload: {
                    isPaused:$paused,
                    reason:$reason
                }
            };

            const Iframe = document.querySelector('#ion-iframe-dialer') as HTMLIFrameElement;
            if(Iframe.contentWindow){
                Iframe.contentWindow.postMessage(params,'*');
                this.collapseWidget(true);
            }
        } catch (error) {
            console.trace( error );
        }
    }


    on(evt:string,cb:any){
        try {
            if(this.callback[evt])
            {
                this.callback[evt] = cb; 
            }  
        } catch (error) {
            console.trace(error);
        }
    }
}
